<template>
  <div class="search-base search-container">
    <search-label-body :label="label" :label-hidden="!label" :columns="options['gridTemplateColumns']">
      <div>
        <vs-select class="w-full" autocomplete v-model="select" :disabled="disabled" @change="change">
          <vs-select-item v-for="(item, i) in items" :key="`${i}_${item}`"
                          :text="typeof item === 'object' ? item.text : item"
                          :value="typeof item === 'object' ? item.value : item"
          />
        </vs-select>
      </div>
    </search-label-body>
  </div>
</template>

<script>
import SearchLabelBody from "@/views/list/components/base/SearchLabelBody.vue";
import FieldSelector from "@/components/selector/FieldSelector.vue";

export default {
  name: "SearchSelect",
  components: {
    FieldSelector,
    SearchLabelBody,
  },
  props: {
    label: {
      default: "사업장명",
      type: String,
    },
    value: String,
    readonly: Boolean,
    query: {
      type: Object,
      default: () => {
        return {
          's_s': '',
        }
      },
    },
    options: Object,
  },
  watch: {
    value(value) {
      this.select = value
    },
  },
  computed: {
    isMobile () {
      return !(this.$store.state.verticalNavMenuWidth === 'default')
    },
    initData() {
      const defaultValue = this.options && this.options['default'] ? this.options['default'] : '';
      const _query_keys = Object.keys(this.query)
      const query = this.$route.query;
      const select = query[_query_keys[0]];
      if (select) {
        try {
          return {
            select: select || defaultValue,
          };
        } catch (e) {}
      }
      return {
        select: defaultValue,
      };
    },
    items() {
      const items = [];
      if (this.useAll) {
        items.push({
          text: "전체",
          value: "",
        });
      }
      items.push(...this.options.items);
      return items;
    },
    disabled() {
      return this.options.disabled || false;
    },
    useAll() {
      return this.options.useAll || false;
    }
  },
  data() {
    return {
      select: "",
    };
  },
  created() {
    this.select = this.initData.select;
    this.$emit("input", this.select);
  },
  methods: {
    change(data) {
      this.$emit("input", data);
    },
  },
};
</script>
